export const labelsPreheaderMobile = [
    {  
        text:"Derco Usados",
        link:"/usados"
    },
    {  
        text:"Garantia Autopia",
        link:"/garantia"
    },
    {  
        text:"Locales",
        link:"/locales"

    },
    {  
        text:"Politicas de privacidad",
        link:"/politicas-privacidad"

    },
    {  
        text:"Preguntas Frecuentes",
        link:"/faq"

    }
]


export const labelsPreHeaders = [
    {  
        text:"Garantia Autopia",
        link:"/garantia"
    },
    {  
        text:"Locales",
        link:"/locales"

    },
    {  
        text:"Blog",
        link:"/blog"

    },
    {  
        text:"Preguntas Frecuentes",
        link:"/faq"

    }
]


export const iconPreheaders = [
    {
        icon:"derco-center-negativo",
        link:"https://www.dercocenter.cl"
    },
    {
        icon:"derco-maq-negativo",
        link:"https://www.dercomaq.cl/"
    },
    {
        icon:"autopia-negativo",
        link:"https://www.autopia.cl/"
    },
    {
        icon:"autoplanet-negativo",
        link:"https://www.autoplanet.cl/"
    },

    {
        icon:"agroplanet-negativo",
        link:"https://www.agroplanet.cl/"
    },
    {
        icon:"derco-negativo",
        link:"https://www.derco.cl"
    }
]
